import { ConfirmDialog } from "shared/components/modals/ConfirmDialog";
import type { LeadSavedViewsController } from "./useLeadSavedViewsController";
import { SaveViewModal } from "./SaveViewModal";

type SavedViewsModalsProps = LeadSavedViewsController["modalsProps"];

export const SavedViewsModals = ({
  nameModal,
  nameError,
  isNamePending,
  onCloseName,
  onClearNameError,
  onSubmitName,
  deleteTarget,
  isDeleting,
  onCloseDelete,
  onConfirmDelete
}: SavedViewsModalsProps) => (
  <>
    <SaveViewModal
      opened={!!nameModal}
      mode={nameModal?.mode ?? "create"}
      initialName={nameModal?.mode === "rename" ? nameModal.view.name : ""}
      isPending={isNamePending}
      error={nameError}
      onClose={onCloseName}
      onSubmit={onSubmitName}
      onClearError={onClearNameError}
    />

    <ConfirmDialog
      opened={!!deleteTarget}
      onClose={onCloseDelete}
      onConfirm={onConfirmDelete}
      variant="danger"
      title="Are you sure you want to delete this view?"
      description="You can always recreate it later by saving your filters again."
      confirmButton={{ label: "Delete", loading: isDeleting }}
      cancelButton={{ label: "Cancel" }}
    />
  </>
);
